export default __webpack_public_path__ + "static/media/location.3b9df869.svg";